export const updateUrl = '/api/user/update';
export const apiUrl = '/api';

export const jobUrl = '/creator';
export const tileUrl = '/tiles';

// export const updateUrl = (baseUrl, params) => {
//     const url = new URL(baseUrl);
//     Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
//     return url.toString();
// }   